import { UISref } from "@uirouter/react";
import { FunctionComponent } from "react";
import styled from "styled-components";
import { PrimaryButton } from "../../components/button";
import { Icon } from "../../components/icons";
import { CenteredFlex, FullSize } from "../../components/layout";
import { H1 } from "../../components/typography";
import { colours } from "../../styles/colours";
import { DashboardRoutes } from "../dashboard/routes";

const Container = styled.div`
  ${CenteredFlex};
  ${FullSize};
  flex-direction: column;
`;

const Header = styled(H1)`
  margin: 2em 0;
`;

const SadFace = styled(Icon).attrs({ type: "close" })`
  display: block;
  font-size: 6em;
  border-radius: 100%;
`;

export const PageNotFoundPage: FunctionComponent = () => (
  <Container>
    <SadFace colour1={colours.grey} colour2={colours.black} />
    <Header>Page not Found</Header>
    <UISref to={DashboardRoutes.name}>
      <PrimaryButton>Take me Home</PrimaryButton>
    </UISref>
  </Container>
);
